import {
  GET_REGISTRATION,
  GET_REGISTRATION_SUCCESS,
  GET_REGISTRATION_FAILED,
} from "./actionsTypes";

export const getRegistration = (params) => {
  return {
    type: GET_REGISTRATION,
    payload: params,
  };
};

export const getRegistrationSuccess = (registration) => {
  return {
    type: GET_REGISTRATION_SUCCESS,
    payload: registration,
  };
};

export const getRegistrationFailed = (error) => {
  return {
    type: GET_REGISTRATION_FAILED,
    payload: error,
  };
};
